$(document).ready(function(){
  //Collection page variant click event
  $(document).on("click", ".card-variants-swatch .swatch-label", function () {
  $(this).closest('.card-variants-swatch').find('.swatch-label').removeClass('active');
  $(this).closest('.swatch-label').addClass('active');
  var variantImage = $(this).attr('data-image');
  console.log('variantImage ',variantImage);
  $(this).closest('.card--media').find('.primary-image').attr('src', variantImage);
  $(this).closest('.card--media').find('.thumbnail .primary-image').attr('srcset', variantImage);
  });

  // Size chart popup
  $(document).on("click", ".size-guide-custom-wrapper", function () {
    $(this).closest("body").toggleClass("popup-open");
  });

  //Popup Close Event

  function PopupClose() {
  $(document).on("click", ".popup-close-event", function () {
    $(this).closest("body").removeClass("popup-open");
  });
    
  }

  $(document).on("click", ".size-popup-close-event", function () {
    $(this).closest("body").removeClass("popup-open");
  });
  $(document).on("click", ".size-variant-popup", function () {
    $(this).closest("body").removeClass("popup-open");
  });

  async function fetchCountryInfo() {
      try {
          // Make a request to ipapi.co to get country information
          const response = await fetch("https://ipapi.co/json/");
          const data = await response.json();
  
          // Extract relevant data
          const countryName = data.country_name;
          const countryISO = data.country;
          const currency = data.currency;
          const flagURL = `https://flagcdn.com/48x36/${countryISO.toLowerCase()}.png`;
  
          // Display data in the HTML element
          document.querySelector('.custom-shipping-item-image').innerHTML = `
              <img src="${flagURL}" alt="Flag of ${countryName}">
          `;
  
          // Append countryISO to the custom-shipping-item-name div
          const customShippingItemName = document.querySelector('.custom-shipping-item-name');
          customShippingItemName.innerHTML = countryISO;

          // Cart Drawer
         const ShippingItemName = document.querySelector('.shipping_country_name');
         const ShippingCurremcy = document.querySelector('.shipping_country');
         ShippingItemName.innerHTML = countryName;
          ShippingCurremcy.innerHTML = currency;

        
      } catch (error) {
          console.error("Error fetching country info:", error);
      }
  }
  
  // Call the function to load country info on page load
  fetchCountryInfo();

    //*********** START product size selelctor dropdwon code
 //   function adjustProductPosition() {
 //    if ($(window).width() <= 767) { 
 //        var productVariant = $(".product-variant-size-option");
 //        $(".product-variant-size-option-cover .overlay").addClass("active");
 //        $(".product-variant-size-option-overlay").append(productVariant).addClass("active");
 //        $("body").css("overflow","hidden");
 //    }
 //   }

 //    function adjustProductOverlay() {
 //      if ($(window).width() <= 767) { 
 //        $(document).on("click",".product-variant-size-option-cover .close-icon",function(){
 //          $(".product-variant-size-option-cover .overlay").removeClass("active");
 //          $(".product-variant-size-option-overlay").removeClass("active");
 //          $("body").css("overflow","visible");
 //        });
 //       }
 //     }
     
 //  $(document).on("click", ".product-variant-size-selector", function () {
 //    $(this).closest(".product-variant-size-selector-select").toggleClass("active");
 //  });

 //  adjustProductPosition();

 //  $(window).resize(adjustProductPosition);
  
 // adjustProductOverlay();
  
 //  $(window).resize(adjustProductOverlay);
  $("body").css("overflow","visible");
   $(document).on("click", ".product-variant-size-selector", function () {
      $(this).closest(".product-variant-size-selector-select").toggleClass("active");
      if ($(window).width() <= 767) { 
          var productVariant = $(".product-variant-size-option");
          $(".product-variant-size-option-cover").addClass("active");
          $(this).closest("body").toggleClass("popup");
          $(".product-variant-size-option-overlay").append(productVariant)
          $("body").css("overflow","hidden");
        
      }
   });
   if ($(window).width() <= 767) { 
      $(document).on("click",".product-variant-size-option-cover .close-icon",function(){
        $(this).closest(".product-variant-size-option-cover").removeClass("active");
        $("body").css("overflow","visible");
      });
   }
  
  $(document).on("click",".product-variant-size", function () {

    $(this).addClass("active");
    $(this).siblings().removeClass("active");
    var selectedSize = $(this).attr("value");
    var $sizeFieldset = $(`.size-variant-fieldset .product-variant-label[data-label-value="${selectedSize}"]`);

    if ($sizeFieldset.length) {
      $sizeFieldset.trigger("click");
    }
    
    // Set the selected size text
    $(".product-variant-size-selector-select").find(".selected-size-value").text(selectedSize);
    $(".product-size-variant .product-variant-selected-title").text(selectedSize);

    // Remove the 'active' class from the dropdown
    $(".product-variant-size-selector-select").removeClass("active");
    $(".close-icon.size-variant-popup").trigger("click");
  });

  $(document).on("click",".popup-close-event", function() {

     $(this).closest('.upsell_popup_wrapper').remove();
     $(this).closest('.upsell_popup_wrapper').removeClass('popup-open');
     $('body').removeClass("upsell-popup-open"); //Add popup open class to body
  });
  //*********** ENd product size selelctor dropdwon code


// START code upsell product ******************

$(document).on("click",".ajax-cart-popup-button", function() {
   var $quickviewPopup = $(this).closest('.upsell-product').find('.upsell-popup .upsell_popup_wrapper').clone();
    var $button = $(this);
    
    // Add the loader to the button
    $button.addClass('loading'); // Assuming you have a class 'loading' with spinner or animation
  
    // Set a timeout of 500ms before displaying the popup
    setTimeout(function() {
      // Remove any previous quickview popup to avoid duplicates
      $('body').find('.upsell_popup_wrapper.popup-open').remove();
      
      // Append the cloned popup to the body
      $('body').append($quickviewPopup);
  
      // Remove the loading class from the button after 2 seconds
      $button.removeClass('loading');
  
      // Add the 'popup-open' class after the loader is done
      $quickviewPopup.addClass('popup-open');
      $('body').addClass("upsell-popup-open"); //Add popup open class to body
  
    }, 500);
});

$(document).on("click",".upsell-close-event", function() {
   $(this).closest('.upsell_popup_wrapper').remove();
   $(this).closest('.upsell_popup_wrapper').removeClass('popup-open');
   $('body').removeClass("upsell-popup-open"); //Add popup open class to body
});
  
// function showPopup(p_id) {
//   const overlay = document.getElementById('overlay_' + p_id);
//   const popup = document.getElementById('popup_' + p_id);

//   overlay.style.display = 'block';
//   popup.classList.add('active');
  
//   document.body.addEventListener('click', function(event) {
//     // Check if the clicked element is a close button
//     if (event.target && event.target.id === 'closeBtn') {
//         // Find the parent popup element ID
//         const popupId = event.target.closest('.popup').id.split('_')[1];
//         // Call hidePopup function with the popup ID
//         hidePopup(popupId);
//     }
//   });
  
//   // Adding event listener to the overlay
//   overlay.addEventListener('click', function(event) {
//       if (event.target === overlay) {
//           hidePopup(p_id);
//       }
//   });
// }

function hidePopup(p_id) {
  const overlay = document.getElementById('overlay_' + p_id);
  const popup = document.getElementById('popup_' + p_id);

  overlay.style.display = 'none';
  popup.classList.remove('active');
}

// document.addEventListener('DOMContentLoaded', function () {
//   const popups = document.querySelectorAll('.upsell-product-popup');
  
//   popups.forEach(function(popup, index) {
//       const cartBtn = popup.querySelector('.popupbtn');
//       const p_id = cartBtn.dataset.productId;

//       cartBtn.addEventListener('click', function() {
//           var $quickviewPopup = $(this).closest('.upsell-product').find('.upsell-popup .upsell_popup_wrapper').clone();

//            // Remove any previous quickview popup to avoid duplicates
//           $('body').find('.upsell_popup_wrapper.popup-open').remove();

//           // Append the cloned popup to the body
//           $('body').append($quickviewPopup);

//           $('body').addClass("upsell-popup-open");
        
//           showPopup(p_id);
//       });
//   });
// });
  
document.addEventListener('DOMContentLoaded', function() {
  const addToCartButtons = document.querySelectorAll('.ajax-cart-btn');
  addToCartButtons.forEach(function(button) {
      button.addEventListener('click', function() {
          const popupId = this.closest('.popup').id.split('_')[1];
          hidePopupWithTransition(popupId);
      });
  });
});
  
function hidePopupWithTransition(p_id) {
    const popup = document.getElementById('popup_' + p_id);
    popup.style.transition = 'opacity 0.5s';
    // Set opacity to 0 with a transition effect
    popup.style.opacity = '0';
    // Hide the popup after the transition ends
    setTimeout(function() {
        hidePopup(p_id);
    }, 500);
}
  
// function hidePopup(p_id) {
//     const overlay = document.getElementById('overlay_' + p_id);
//     const popup = document.getElementById('popup_' + p_id);
//     overlay.style.display = 'none';
//     popup.classList.remove('active');
//     // Restore opacity to 1 after hiding the popup
//     popup.style.opacity = '1';
// }
  
  $(".Add-on").on("click", function() {
    $(this).parents(".variants-swatch").find(".Add-on").removeClass("active");
    $(this).addClass("active");
    var popupSelector = $(this).parents(".popup").attr("id");
    var valuesArray = "";
    $(this).parents(".popup").find(".Add-on.active").each(function() {
      var optionValue = $(this).data("value");
      valuesArray = `${valuesArray} ${optionValue}`;
    }); 
    console.log("valuesArray = ", valuesArray);
    var trimmedValue = String(valuesArray).trim();
        selectedVariant = $(`#${popupSelector} .select__select option[data-variant="${trimmedValue}"]`);
        onChangeGetVariantID = selectedVariant.attr("value");
    console.log(onChangeGetVariantID, "onChangeGetVariantID==============");
    $(this).parents(".popup").find(".product-form input[name='id']").val(onChangeGetVariantID);
  }); 
  
  buttonTextChange();
  
  function buttonTextChange() {
    if (window.location.href.indexOf("products") > -1){
      $(".upsell-product").each(function(){
       var upsellProductHandle = $(this).data("handle");
        console.log("upsellProductHandle => ", upsellProductHandle);
       $.ajax({
           type: 'GET',
           url: '/cart.json',
           dataType: 'jsonp',
           success: function(data) {
             var items = data['items'];
             for (var i = 0; i < items.length; i++) {
                 if (items[i]["handle"] == upsellProductHandle) {
                   $(".upsell-product[data-handle="+upsellProductHandle+"] .popupbtn span").text("Added");
                 }
             }
           }
       });
      });
    }
  }
  // document.addEventListener("DOMContentLoaded", function() {
  //     var cartBtn = document.getElementById("cart-btn");
  //     var popup = document.querySelector(".popup");
  
  //     cartBtn.addEventListener("click", function() {
  //         popup.classList.add("active");
  //     });
  // });

    function changeVariant(element) {
      // Remove 'is-active' class from all labels within the closest fieldset
      element.closest(".upsell-variant-content").find("label").removeClass("is-active");
      // Add 'is-active' class to the clicked label
      element.addClass("is-active");
      
     var selectedswatchValue = element.attr('data-variant-value');
      element.closest(".product-form-variant-wrapper").find(".product-variant-text").text(selectedswatchValue);
      // Initialize an empty array to store selected values from all fieldsets
      var selectedValues = [];
      // Loop through each fieldset within the '.quickview-variants-wrapper'
      element.closest(".card-variants-swatch").find(".upsell-variant-content").each(function() {
          // Find the active label and get its 'data-value' attribute
          var activeValue = $(this).find("label.is-active").data("variant-value") || "";
          if (activeValue) {
              selectedValues.push(activeValue); // Add the active value to the array
          }
      });
      // Join the selected values with " / " separator
      var comb = selectedValues.join(" / ");
      // Find the variant based on the combined value
      var selector = "[variant-title='" + comb + "']";
      var selectedVariantElement = element.closest(".card-variants-swatch").find(".all-variants " + selector);
      var selectedVariantID = selectedVariantElement.data("variants-id");
      var selectedVariantImage = selectedVariantElement.data("variant-image");
      // Set the variant ID to the product AJAX cart button
      element.closest(".card-wrapper").find(".ajax-cart-btn").attr("data-variant-id", selectedVariantID);
      element.closest(".card-wrapper").find(".upsell-product-image").attr("src", selectedVariantImage);

      var selectedVariantprice = selectedVariantElement.data("variant-price");
      element.closest(".card-wrapper").find(".price-item--sale.price-item--last").text(selectedVariantprice);
      
      
    }
  $(document).on("click",".card-variants-swatch .upsell-variant-content label", function () {
    changeVariant($(this));
  });
  
  $(document).on("click",".ajax-add-to-cart",function() {
    var ajaxVariantID = $(this).data("variant-id");
    addToCartJS(1,ajaxVariantID,$(this));
  });
  function addToCartJS(qty, variantID, btn) {
    // Open the cart drawer
    var cartDrawer = document.querySelector('cart-drawer');
    var sectionsToRender = cartDrawer.getSectionsToRender().map((section) => section.id)
    var sections_url = window.location.pathname;
    // Send request to add item to cart
    fetch("/cart/add.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ "quantity": qty, "id": variantID, "sections" : sectionsToRender, "sections_url" : sections_url})
    })
    .then(response => response.json())
    .then(response => {
      cartDrawer.renderContents(response);
      cartDrawer.open();
      if (cartDrawer && cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
      PopupClose();
    })
    .catch(error => {
        console.error("Error adding item to cart:", error);
    });
  } 
// ****************** Cart drower js start *******************

// ****************** CART UPSELL js start *******************

// CART UPSELL JS
  $(document).on("change", ".upsell_variant_select", function () {
    var selectedOption = $(this).find("option:selected");
    var variantId = selectedOption.attr("option-variant-id");
    $(this)
      .parents(".upsell-variant-buybutton")
      .find(".upsell-product-btn")
      .attr("upsell-product-variantid", variantId);
    // console.log('Updated variant ID: ', variantId);
  });

  $(document).on("click", ".upsell-product-ajax", function () {
    var variantId = $(this).attr("upsell-product-variantID");
    $(this).addClass("is_loading");
    addToCart_Ajax(1, variantId, $(this));
  });

  // Add to Cart function with callback
  function addToCart_Ajax(qty, variantID, btn) {
    var cartDrawer = document.querySelector("cart-drawer");
    var sectionsToRender = cartDrawer
      .getSectionsToRender()
      .map((section) => section.id);
    var sections_url = window.location.pathname;
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        quantity: qty,
        id: variantID,
        sections: sectionsToRender,
        sections_url: sections_url,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        btn.removeClass("is_loading");
        cartDrawer.renderContents(response);
        cartDrawer.open();
        if (cartDrawer && cartDrawer.classList.contains("is-empty"))
          cartDrawer.classList.remove("is-empty");
      })
      .catch((error) => {
        console.error("Error adding item to cart:", error);
      });
  }

  $(document).on("click", ".header__icon--cart", function () {
    // Correct way to get the breakpoint from the dataset
    var breakpoint = $(this).data("breakpoint"); // jQuery's .data() is used for getting data-* attributes

    // Add the class with the proper concatenation
    document.body.classList.add("overflow-hidden");
  });

// ****************** CART UPSELL js end *******************

  // ************ kaching-bundle app *********************

  var interval = setInterval(function () {
    if ($('kaching-bundle').length > 0) {
        $('kaching-bundle').after($('.product-form'));
        clearInterval(interval);
    }
  }, 100);


   //product page trustpilot review slider
    function initSwiper (){
      $(".cart-product-upsell").owlCarousel({
        nav: true,
        dots: false,
        loop: false,
        touchDrag: false,
        mouseDrag: false,
        margin: 20,
        rewind: false,
        responsive: {
          320: {
            items: 2,
          },
          480: {
            items: 2,
          },
          750: {
            items: 2,
          },
          1099: {
            items: 3,
          },
          1109: {
            items: 3,
          },
          1441: {
            items: 3,
          },
        },
      });
    }

  initSwiper();
let throttleTimeout = null;
  function observeCartDrawer() {
    const cartDrawer = document.querySelector("cart-drawer");
  
    if (cartDrawer) {
      const observer = new MutationObserver(function (mutations) {
        const clickedInsideCollection = mutations.some(mutation =>
          mutation.target.closest(".cart-drawer-upsell")
        );
        if (!clickedInsideCollection && !throttleTimeout) {
          throttleTimeout = setTimeout(() => {
           initSwiper();
            fetchCountryInfo();
            throttleTimeout = null; // Reset throttle
          }, 1000); // 1-second throttle to prevent repeated calls
        }
      });
  
      observer.observe(cartDrawer, {
        childList: true,
        subtree: true
      });
    }
  }
// Initialize observer
  // observeCartDrawer();
  
});

//Motivator Product JS Start
var motivatorProduct = false;
document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", function (event) {
    var target = event.target;
    if (target.classList.contains("click_gift")) {
      var isChecked = target.checked;
      fetch("/cart.json")
        .then((response) => response.json())
        .then((data) => {
          var items = data.items;
          var foundMotivatorProduct = items.some(
            (item) => item.handle === motivatorProductHandle
          );
          if (isChecked && !foundMotivatorProduct) {
            addMotivatorProduct(motivatorProductVariantID);
          } else if (!isChecked) {
            removeMotivatorProduct(motivatorProductVariantID);
          }
        });
    }
  });
});

function addMotivatorProduct(motivatorProductVariantID) {
  var xhr = new XMLHttpRequest();
  var url = "/cart/add.js";
  xhr.open("POST", url, true);
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4 && xhr.status === 200) {
      var parsedState = JSON.parse(xhr.responseText);
      document.querySelector("cart-drawer").renderContents(parsedState);
      $(".click_gift").prop("checked", true);
    }
  };
  var cartDrawer = document.querySelector("cart-drawer");
  var sectionsToRender = cartDrawer
    .getSectionsToRender()
    .map((section) => section.id);
  var sections_url = window.location.pathname;
  var data = JSON.stringify({
    quantity: 1,
    id: motivatorProductVariantID,
    sections: sectionsToRender,
    sections_url: sections_url,
  });
  xhr.send(data);
}

function removeMotivatorProduct(motivatorProductVariantID) {
  var cartDrawer = document.querySelector("cart-drawer");
  var xhr = new XMLHttpRequest();
  var url = "/cart/change.js";
  xhr.open("POST", url, true);
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4 && xhr.status === 200) {
      var parsedState = JSON.parse(xhr.responseText);
      document.querySelector("cart-drawer").renderContents(parsedState);
      $(".click_gift").prop("checked", false);
    }
  };
  var cartDrawer = document.querySelector("cart-drawer");
  var sectionsToRender = cartDrawer
    .getSectionsToRender()
    .map((section) => section.id);
  var sections_url = window.location.pathname;
  var data = JSON.stringify({
    quantity: 0,
    id: motivatorProductVariantID,
    sections: sectionsToRender,
    sections_url: sections_url,
  });
  xhr.send(data);
}
//Motivator Product JS END


  // ****************** Cart drower js End *******************
  